exports.install = function (Vue) {
  // Vue.prototype.$target = "http://127.0.0.1:9528/dev-api"; // 本地后端地址
  // Vue.prototype.$targetUrl = "http://127.0.0.1:9528/"; // 本地后端地址
  // Vue.prototype.$target = "https://zmsk.zhsh10000.com/dev-api"; // 测试环境
  // Vue.prototype.$targetUrl = "https://zmsk.zhsh10000.com/"      // 测试环境
  Vue.prototype.$target = "https://www.zhsh10000.com/dev-api"; //  生产环境
  Vue.prototype.$targetUrl = "https://www.zhsh10000.com/"    // 生产环境
  // 封装提示成功的弹出框
  Vue.prototype.notifySucceed = function (msg) {
    this.$notify({
      title: "成功",
      message: msg,
      type: "success",
      offset: 100
    });
  };
  // 封装提示失败的弹出框
  Vue.prototype.notifyError = function (msg) {
    this.$notify.error({
      title: "错误",
      message: msg,
      offset: 100
    });
  };
}
